import { createI18n } from 'vue-i18n'
import { App, computed } from 'vue'

export const languages = computed<{ label: string; value: string }[]>(() => {
  const langs = [
    { label: 'English', value: 'en' },
    { label: 'Deutsch', value: 'de' },
    { label: 'Español', value: 'es' },
    { label: 'Français', value: 'fr' },
    { label: 'Italiano', value: 'it' },
    { label: 'Polski', value: 'pl' },
    { label: 'Pусский', value: 'ru' },
    { label: 'Português', value: 'pt' },
    { label: 'Türkçe', value: 'tr' },
  ]

  return langs
})

export const defaultLanguage = 'en'

export const i18n = createI18n({
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  messages: {},
})

export function registerI18nPlugin(app: App) {
  app.use(i18n)
}
